import type React from 'react';
import { Box, Spinner } from '@zillow/constellation-10';
import DataCard from 'app/shared/components/DataCard';
import AutocompleteAreaInput from 'app/shared/components/AutocompleteAreaInput';
import type { RegionSuggestionsDto } from '@zg-rentals/ts-rental-growth-api-client';

interface SearchMarketsProps {
  submit: (region: RegionSuggestionsDto) => void;
  isLoading: boolean;
  error: string | null;
}

const SearchMarkets: React.FunctionComponent<React.PropsWithChildren<React.PropsWithChildren<SearchMarketsProps>>> = (
  props,
) => {
  const { submit, isLoading, error } = props;
  return (
    <DataCard
      heading="Stay on top of market trends in your area"
      copyText="Understand median rent prices, compare markets, and renter expectations in the market."
      useFullScreen={true}
      addMarginTop={true}
    >
      <Box css={{ display: 'flex' }}>
        <AutocompleteAreaInput submit={submit} error={error} label="Enter a market to explore trends" showLabel />
        {isLoading && <Spinner size="md" css={{ marginLeft: '200' }} />}
      </Box>
    </DataCard>
  );
};

export default SearchMarkets;
